module.exports = "<p>\n  view-customer works!\n</p>\n"